import React, { Component } from "react";
import { Link } from 'react-router';
import axios from "axios";
import $ from 'jquery';
import moment from 'moment';
import moment1 from 'moment-timezone';

import SimpleReactValidator from 'simple-react-validator';
import { isChrome as chrome,isMobile as mobileTab,isMobileOnly as omobile,isTablet as tablete,isBrowser as browser,isSmartTV as smarttv,isWearable as wearable,isAndroid as android,isWinPhone as winphone,isIOS as ios,isFirefox as ff,isSafari as safari,isOpera as opera,isIE as ie,isEdge as edge,isYandex as yandex,isChromium as chromium,isMobileSafari as mobsafari,osVersion as version,osName as osname,fullBrowserVersion as fbrowserversion,browserVersion as browserVer,browserName as browserName,mobileVendor as mobvendor,mobileModel as mobmodel,engineName as engName,engineVersion as engversion,getUA as getua,deviceType as deviceType,isIOS13 as ios13,isIPhone13 as iphone13,isIPad13 as ipad13,isIPod13 as ipod13,isElectron as isElectron,deviceDetect as devicedetect} from "react-device-detect";
import {  browserHistory } from 'react-router'
import Countdown from 'react-countdown-now';
import Login from '../auth/Login';
import MainSignUp from '../auth/MainSignUp';
import ChargingSession from '../home/ChargingSession';
import { submitHost } from '../../util/submitHost';
import { verify } from '../../util/verify';
import { channelCheckUser } from '../../util/channelCheckUser';
import Calendar from 'react-calendar';
import TimePicker from 'react-time-picker';
import Header from './Header';
import { connect } from "react-redux";
import { showMainErrorPop } from '../../actions/popups';
import ReactLightCalendar from '@lls/react-light-calendar'
import '@lls/react-light-calendar/dist/index.css'
import SupportContainer from '../home/SupportContainer';
import TokenSetup from '../home/TokenSetup';
import EmbedSubdomain from '../home/EmbedSubdomain';


class ChannelSettings extends Component {
constructor(props) {
	super(props);
	
	if ( !localStorage.getItem('userData') )
		{
			window['user_loggedIn'] = 0;
			var adminpath = process.env.REACT_APP_PATH+'/login';
			window.location.href = adminpath;
			return false;
		}
	
	this.state = {
		sessionProperty: true,
		sessionPublishPage: true,
		sessionSearchable: true,
		showOtherParticipants: true,
		showHostParticipant: true,
		startRecording: true,
		sessionViewDemand: true,
		requireCamera: true,
		firstTabOnDemand: false,
		showLiveTab: false,
		showOndemandTab: false,
		disableNotificationSound: false,
		allowSessionProperty: true,
		allowSessionPublicChannel: true,
		allowSessionSearchable: true,
		allowShowOtherParticipants: true,
		allowShowHostParticipant: true,
		allowStartRecording: true,
		allowSessionViewDemand: true,
		allowRequireCameraHost: true,
		allowDisableNotificationSound: true,
		defaultRepsTime: 0,
		openedFromComp: true,
		existSubdomain: false,
		emptySubdomain: false,
		showWatermark: true,
		watermark_image: '',
		backroundColorPick: '',
		fontColorPick: '',
		fontTitleColorPick: '',
		buttonsColorPick: '',
		highlightColorPick: '',
		channelMainData: {},
		subdomain: '',
		fullsubdomain: '',
		fullsubdomaininvite: '',
		searchInputBorder: '',
		buttonsTextColor: '',
		activeTabColor: '',
		dateHolderColor: '',
		chosenOptionColor: '',
		searchBackground: '',
		searchFont: '',
		searchInputBackground: '',
		createUser: false,
		showWaiver: true,
		waiver_pdf: '',
		mainFaqs: [],
		selectedMenu: 'Member Integration',
		sendClientsEmail: false,
		createAccounts: false,
		verifyMembers: false,
		usernameMindbody: '',
		passwordMindbody: '',
		siteIdMindbody: '',
		usernameCSI: '',
		passwordCSI: '',
		mindBodyInfo: false,
		authenticateClientsMindbody: false,
		authenticateStaffMindbody: false,
		authenticateSessionsMindbody: false,
		authenticateBookingsMindbody: false,
		waiverShowLink: '',
		showIfUploaded: false,
		endDate:'',
		whenSessionTime:'',
		sessionCalender: '',
		time2: '',
		authenticateClientsCSI: false,
		memberNum: 0,
		intergrateMembers: false,
		channelCreateUser: false,
		csiIntegration: false,
		emailMessage: '',
		emailMessageMindbody: '',
		documentViewWaiver: null,
		hostsArray: [],
		responsibleAdmin: 0,
		reponsibleAdminName: '',
		isOpenHostsDrop: false,
		supportPageName: 'Channel Settings',
		supportPageApi: '/ChannelSettings',
		userTypeFaqs: 2,
		submenuExternal: 'External API'
	}
}

componentDidMount(){
	this.showChannelData();
	this.getHosts();
}

updateState = (newState) => {
	this.setState(newState);
}


getHosts=()=>{
	let postdata = { id: JSON.parse(localStorage.getItem('userData')).data.responseData.channel, dashStatus : true }
    axios.post(process.env.REACT_APP_NAME+"/api/v1/user/getChannelHosts", postdata).then(res => {
		this.setState({ hostsArray: res.data.responseData });
	}).catch(err =>{ });
}

openHostsDrop=()=>{
	var isOpen = this.state.isOpenHostsDrop;
	isOpen = !isOpen;
	this.setState({isOpenHostsDrop: isOpen});
}

selectHost=(host)=>{
	if ( this.state.responsibleAdmin !==  host.userId)
		{
			this.setState({responsibleAdmin: host.userId, reponsibleAdminName: host.username});
		}
	else
		{
			this.setState({responsibleAdmin: 0, reponsibleAdminName: ''});
		}
	
	this.openHostsDrop();
}

preventDef=(e)=> {
	e.preventDefault();
	e.stopPropagation();
};

updateStateMember = (newState) => {
	this.setState(newState, ()=>{
			let createVirdioUser = this.state.channelCreateUser===false?0:1;
			console.log(createVirdioUser);
			axios.post(process.env.REACT_APP_NAME+"/api/v1/channel/updateMemberCreateUser", {'createUser' : createVirdioUser, 'channelId' : JSON.parse(localStorage.getItem('userData')).data.responseData.channel})          
			.then(res => {
				console.log('succ');
			})
			.catch(err =>{ }); 
		}
	);
}

updateStateIntegration = (newState) => {
	this.setState(newState, ()=>{
			let integration = this.state.intergrateMembers===false?0:1;
			axios.post(process.env.REACT_APP_NAME+"/api/v1/channel/updateMemberIntegration", {'mindbodyIntegretion' : integration, 'channelId' : JSON.parse(localStorage.getItem('userData')).data.responseData.channel})          
			.then(res => {
				console.log('succ');
			})
			.catch(err =>{ }); 
		}
	);
}

updateStateCsi = (newState) => {
	this.setState(newState, ()=>{
			let csiIntegration = this.state.csiIntegration===false?0:1;
			axios.post(process.env.REACT_APP_NAME+"/api/v1/channel/updateCsiIntegration", {'csiIntegration' : csiIntegration, 'channelId' : JSON.parse(localStorage.getItem('userData')).data.responseData.channel})          
			.then(res => {
				console.log('succ');
			})
			.catch(err =>{ }); 
		}
	);
}

setPlaceholderToValue=(e)=>{
	if ( this.state.channelData[0] )
		{
			let subdomain = this.state.channelData[0].name.toLowerCase().replace(/\s/g, '');
			this.setState({ subdomain: subdomain});
		}
}

showChannelData=(e)=>
{
	let token = JSON.parse(localStorage.getItem('userData')).data.responseData.token;
	axios.defaults.headers.common['Authorization'] = token;	
	
	axios.post(process.env.REACT_APP_NAME+"/api/v1/channel/insertChannelSettings",{"channel_id": JSON.parse(localStorage.getItem('userData')).data.responseData.channel})
	.then(res_e => {
		this.setState({
			sessionProperty: res_e.data.responseData.publicSession===0?false:true,
			createUser: res_e.data.responseData.createUser===0?false:true,
			showWatermark: res_e.data.responseData.showWatermark===0?false:true,
			showWaiver: res_e.data.responseData.showWaiver===0?false:true,
			sessionPublishPage: res_e.data.responseData.publishChannelPage===0?false:true,
			sessionSearchable: res_e.data.responseData.sessionSearchable===0?false:true,
			showOtherParticipants: res_e.data.responseData.showParticipants===0?false:true,
			showHostParticipant: res_e.data.responseData.showHostParticipant===0?false:true,
			startRecording: res_e.data.responseData.recordSession===0?false:true,
			sessionViewDemand: res_e.data.responseData.sessionOnDemandFree===0?false:true,
			requireCamera: res_e.data.responseData.requireCamera===0?false:true,
			firstTabOnDemand: res_e.data.responseData.firstTabOnDemand===0?false:true,
			showLiveTab: res_e.data.responseData.showLiveTab===0?false:true,
			showOndemandTab: res_e.data.responseData.showOndemandTab===0?false:true,
			disableNotificationSound: res_e.data.responseData.disableNotificationSound===0?false:true,
			allowSessionProperty: res_e.data.responseData.allowSessionProperty===0?false:true,
			allowSessionPublicChannel: res_e.data.responseData.allowSessionPublicChannel===0?false:true,
			allowSessionSearchable: res_e.data.responseData.allowSessionSearchable===0?false:true,
			allowShowOtherParticipants: res_e.data.responseData.allowShowOtherParticipants===0?false:true,
			allowShowHostParticipant: res_e.data.responseData.allowShowHostParticipant===0?false:true,
			allowStartRecording: res_e.data.responseData.allowStartRecording===0?false:true,
			allowSessionViewDemand: res_e.data.responseData.allowSessionViewDemand===0?false:true,
			allowRequireCameraHost: res_e.data.responseData.allowRequireCameraHost===0?false:true,
			allowDisableNotificationSound: res_e.data.responseData.allowDisableNotificationSound===0?false:true,
			intergrateMembers: res_e.data.responseData.mindbodyIntegretion===0?false:true,
			channelCreateUser: res_e.data.responseData.createUser===0?false:true,
			csiIntegration: res_e.data.responseData.csiIntegration===0?false:true,
			watermark_image: res_e.data.responseData.watermark,
			waiver_pdf: res_e.data.responseData.waiverLink,
			documentViewWaiver: res_e.data.responseData.waiverLink,
			emailMessage: res_e.data.responseData.emailMessage,
			emailMessageMindbody: res_e.data.responseData.emailMessageMindbody,
			whenSessionTime: res_e.data.responseData.waiverEndDate ? moment(res_e.data.responseData.waiverEndDate).format('MMM D, YYYY') : '',
			endDate: res_e.data.responseData.waiverEndDate ? moment(res_e.data.responseData.waiverEndDate).format('YYYY-MM-DD') : '',
			backroundColorPick: res_e.data.responseData.backgroundColor ? res_e.data.responseData.backgroundColor : '#000000',
			fontColorPick: res_e.data.responseData.fontColor ? res_e.data.responseData.fontColor : '#DDDDDD',
			fontTitleColorPick: res_e.data.responseData.fontTitleColor ? res_e.data.responseData.fontTitleColor : '#BCA4FF',
			buttonsColorPick: res_e.data.responseData.buttonsColor ? res_e.data.responseData.buttonsColor : '#E4DAFF',
			highlightColorPick: res_e.data.responseData.highlightTextColor ? res_e.data.responseData.highlightTextColor : '#BCA4FF',
			searchBackground: res_e.data.responseData.searchBackground ? res_e.data.responseData.searchBackground : '#24223D',
			searchFont: res_e.data.responseData.searchFont ? res_e.data.responseData.searchFont : '#ffffff',
			searchInputBackground: res_e.data.responseData.inputBackground ? res_e.data.responseData.inputBackground : '#24223D',
			searchInputBorder: res_e.data.responseData.searchBorder ? res_e.data.responseData.searchBorder : '#ffffff',
			buttonsTextColor: res_e.data.responseData.buttonsTextColor ? res_e.data.responseData.buttonsTextColor : '#6D118C',
			activeTabColor: res_e.data.responseData.activeTabColor ? res_e.data.responseData.activeTabColor : '#EFF0F7',
			dateHolderColor: res_e.data.responseData.dateHolderColor ? res_e.data.responseData.dateHolderColor : '#24223D',
			chosenOptionColor: res_e.data.responseData.chosenOptionColor ? res_e.data.responseData.chosenOptionColor : '#6D118C',
		}, ()=>{
			
				let waiver_link = '';
				if ( this.state.waiver_pdf !== null && this.state.waiver_pdf !== '' )
					{
						waiver_link = 'https://docs.google.com/gview?url='+encodeURIComponent(this.state.waiver_pdf)+'&embedded=true&t='+(new Date().getTime());
					}
				
				this.setState({ waiverShowLink: waiver_link });
				
				if ( this.state.endDate != '' )
					{
						let waiverBaseDateInfo = this.state.endDate;
						let waiverBaseDate = new Date(waiverBaseDateInfo);
						this.setState({ sessionCalender: waiverBaseDate });
					}
				
			});
		
		if(this.state.openedFromComp)
			{
				this.setState({
					defaultRepsTime: res_e.data.responseData.defaultRepsTime
				});
			}
			
	}).catch(err =>{ });
	
	axios.post(process.env.REACT_APP_NAME+"/api/v1/channel/getChannelById",{"channelId": JSON.parse(localStorage.getItem('userData')).data.responseData.channel})
	.then(res => {
		this.setState({channelMainData: res.data.responseData})
		let adminpath = process.env.REACT_APP_PATH;
		adminpath = adminpath.replace('http://', '.').replace('https://', '.');
					
		this.setState({ subdomain: res.data.responseData.subdomain, fullsubdomain: res.data.responseData.subdomain + adminpath, fullsubdomaininvite: res.data.responseData.subdomain + '-signup' + adminpath})
	}).catch(err =>{ });
	
	this.checkAuthInt();
}

checkAuthInt = () => {

	axios.post(process.env.REACT_APP_NAME+"/api/v1/channel/getChannelIntegration",{"channelId": JSON.parse(localStorage.getItem('userData')).data.responseData.channel})
	.then(res => {
		
		if ( res.data.responseData && res.data.responseData['integration'] && res.data.responseData['integration']['apiName'] )
			{		
				var responsibleAdminName = res.data.responseData['integration']['firstName'] + ' ' + res.data.responseData['integration']['lastName'];
				this.setState({mindBodyInfo: res.data.responseData['integration'], responsibleAdmin: res.data.responseData['integration']['responsibleAdmin'], reponsibleAdminName: responsibleAdminName});
				if ( res.data.responseData.integration.syncBooking ) { this.setState({authenticateBookingsMindbody: true}); }
				else { this.setState({authenticateBookingsMindbody: false}); }
				if ( res.data.responseData.integration.syncClients ) { this.setState({authenticateClientsMindbody: true}); }
				else { this.setState({authenticateClientsMindbody: false}); }
				if ( res.data.responseData.integration.syncSessions ) { this.setState({authenticateSessionsMindbody: true}); }
				else { this.setState({authenticateSessionsMindbody: false}); }
				if ( res.data.responseData.integration.syncStaff ) { this.setState({authenticateStaffMindbody: true}); }
				else { this.setState({authenticateStaffMindbody: false}); }
			}
		else
			{
				this.setState({mindBodyInfo: false, authenticateBookingsMindbody: false, authenticateClientsMindbody: false, authenticateSessionsMindbody: false, authenticateStaffMindbody: false});
			}
		
		$('.main_loader').attr({'style':'display: none'});
		
	}).catch(err =>{ $('.main_loader').attr({'style':'display: none'}); });
	
}

resetDefaultSettings =()=>{
	this.setState({
		backroundColorPick: '#000000',
		fontColorPick: '#DDDDDD',
		fontTitleColorPick: '#BCA4FF',
		buttonsColorPick: '#E4DAFF',
		highlightColorPick: '#BCA4FF',
		searchBackground: '#24223D',
		searchFont: '#ffffff',
		searchInputBackground: '#24223D',
		searchInputBorder: '#ffffff',
		buttonsTextColor: '#6D118C',
		activeTabColor: '#EFF0F7',
		dateHolderColor: '#24223D',
		chosenOptionColor: '#6D118C'
	})
}
changeWatermark =(e)=>{
	let file = e.target.files[0];
	if ( file.type === 'image/png' || file.type === 'image/jpeg' )
		{
			
			var mthis = this;
			var fr=new FileReader();
			fr.onload = function(e)
				{
					$('.main_loader').attr({'style':'display:flex'});
					
					const data = new FormData();
					data.append('file', file);
					
					axios.post(process.env.REACT_APP_NAME+"/api/v1/upload/upload", data)
					.then(res => {
						mthis.setState({watermark_image: res.data.responseData.file},()=>{ $('.main_loader').hide(); });
					}).catch(err =>{ $('.main_loader').hide(); });
				};
			fr.readAsDataURL(file);
		}
		
	else
		{
			this.props.showMainErrorPop("Only .png and .jpeg extensions are supported");
		}
}

changeWaiver =(e)=>{
	let file = e.target.files[0];
	if ( file.type === 'application/pdf' )
		{
			
			var mthis = this;
			var fr=new FileReader();
			fr.onload = function(e)
				{
					$('.main_loader').attr({'style':'display:flex'});
					const data = new FormData();
					data.append('file', file);
					
					axios.post(process.env.REACT_APP_NAME+"/api/v1/upload/upload", data)
					.then(res => {
						var waiverNew = 'https://docs.google.com/gview?url='+encodeURIComponent(res.data.responseData.file)+'&embedded=true&t='+(new Date().getTime());
						mthis.setState({waiver_pdf: res.data.responseData.file, waiverShowLink: waiverNew, showIfUploaded: true}, ()=>{ $('.main_loader').hide(); });
					}).catch(err =>{ $('.main_loader').hide(); });
				};
			fr.readAsDataURL(file);
		}
		
	else
		{
			this.props.showMainErrorPop("Only .pdf extension is supported");
		}
}

updateChannelDefaultSettings=(fromMindbodyTab)=>{
	this.state.openedFromComp = false;
	let token = JSON.parse(localStorage.getItem('userData')).data.responseData.token;
	axios.defaults.headers.common['Authorization'] = token;	
	let currentDate = new Date();
	let waiverExpireDate;
	
	if( this.state.endDate )
		{
			waiverExpireDate = this.state.endDate;
		}
		
	let currentDateFormat = moment(currentDate).format('YYYY-MM-DD');

	if(this.state.showWatermark && !fromMindbodyTab)

		{
			if(this.state.watermark_image == null)
				{
					this.props.showMainErrorPop('If you want On-Demand Recording Watermark you need to upload Watermark image first');
					this.setState({ selectedMenu : 'Channel Settings' });
					return false;
				}
		}
	
	if(this.state.showWaiver && !fromMindbodyTab)

		{
			if(!this.state.showIfUploaded && this.state.waiver_pdf == null)
				{
					this.props.showMainErrorPop('If you want Waivers for Members you need to upload Waiver Document first');
					this.setState({ selectedMenu : 'Channel Settings' });
					return false;
				}
				
			if(waiverExpireDate < currentDateFormat || !waiverExpireDate)
				{
					this.props.showMainErrorPop('If you want Waivers for Members you need to select a date in future');
					this.setState({ selectedMenu : 'Channel Settings' });
					return false;
				}
		}
		
	if(this.state.defaultRepsTime != '' && this.state.defaultRepsTime <= 200)
		{
			this.setState({
				sessionProperty: this.state.sessionProperty===false?0:1,
				channelCreateUser: this.state.channelCreateUser===false?0:1,
				showWatermark: this.state.showWatermark===false?0:1,
				showWaiver: this.state.showWaiver===false?0:1,
				sessionPublishPage: this.state.sessionPublishPage===false?0:1,
				sessionSearchable: this.state.sessionSearchable===false?0:1,
				showOtherParticipants: this.state.showOtherParticipants===false?0:1,
				showHostParticipant: this.state.showHostParticipant===false?0:1,
				startRecording: this.state.startRecording===false?0:1,
				sessionViewDemand: this.state.sessionViewDemand===false?0:1,
				requireCamera: this.state.requireCamera===false?0:1,
				firstTabOnDemand: this.state.firstTabOnDemand===false?0:1,
				showLiveTab: this.state.showLiveTab===false?0:1,
				showOndemandTab: this.state.showOndemandTab===false?0:1,
				disableNotificationSound: this.state.disableNotificationSound===false?0:1,
				allowSessionProperty: this.state.allowSessionProperty===false?0:1,
				allowSessionPublicChannel: this.state.allowSessionPublicChannel===false?0:1,
				allowSessionSearchable: this.state.allowSessionSearchable===false?0:1,
				allowShowOtherParticipants: this.state.allowShowOtherParticipants===false?0:1,
				allowShowHostParticipant: this.state.allowShowHostParticipant===false?0:1,
				allowStartRecording: this.state.allowStartRecording===false?0:1,
				allowSessionViewDemand: this.state.allowSessionViewDemand===false?0:1,
				allowRequireCameraHost: this.state.allowRequireCameraHost===false?0:1,
				allowDisableNotificationSound: this.state.allowDisableNotificationSound===false?0:1
			});
			
			this.props.showMainErrorPop("Changes have been applied");

			axios.post(process.env.REACT_APP_NAME+"/api/v1/channel/updateChannelSettings",{"channel_id": JSON.parse(localStorage.getItem('userData')).data.responseData.channel, "publicSession": this.state.sessionProperty, "publishSession" : this.state.sessionPublishPage, "sessionSearchable" : this.state.sessionSearchable, "showOtherParticipants" : this.state.showOtherParticipants, "showHostParticipant" : this.state.showHostParticipant, "startRecording" : this.state.startRecording, "sessionViewDemand" : this.state.sessionViewDemand, "requireCamera" : this.state.requireCamera, "allowSessionProperty" : this.state.allowSessionProperty, "allowSessionPublicChannel" : this.state.allowSessionPublicChannel, "allowSessionSearchable" : this.state.allowSessionSearchable, "allowShowOtherParticipants" : this.state.allowShowOtherParticipants, "allowShowHostParticipant" : this.state.allowShowHostParticipant, "allowStartRecording" : this.state.allowStartRecording, "allowSessionViewDemand" : this.state.allowSessionViewDemand, "allowRequireCameraHost" : this.state.allowRequireCameraHost, "defaultRepsTime" : this.state.defaultRepsTime, 'watermark' : this.state.watermark_image, 'showWatermark' : this.state.showWatermark, 'backgroundColorPick' : this.state.backroundColorPick, 'fontColorPick' : this.state.fontColorPick, 'fontTitleColorPick' : this.state.fontTitleColorPick, 'buttonsColorPick' : this.state.buttonsColorPick, 'highlightColorPick' : this.state.highlightColorPick, 'searchBackground' : this.state.searchBackground, 'searchFont' : this.state.searchFont, 'searchInputBorder' : this.state.searchInputBorder, 'buttonsTextColor': this.state.buttonsTextColor, 'activeTabColor' : this.state.activeTabColor,'dateHolderColor': this.state.dateHolderColor ,'chosenOptionColor': this.state.chosenOptionColor,'searchInputBackground' : this.state.searchInputBackground, 'createUser' : this.state.channelCreateUser, 'showWaiver' : this.state.showWaiver, 'waiverLink' : this.state.waiver_pdf, 'endDate' : waiverExpireDate, 'emailMessage' : this.state.emailMessage, 'emailMessageMindbody': this.state.emailMessageMindbody, 'firstTabOnDemand': this.state.firstTabOnDemand,'showLiveTab': this.state.showLiveTab, 'showOndemandTab': this.state.showOndemandTab, disableNotificationSound: this.state.disableNotificationSound, allowDisableNotificationSound: this.state.allowDisableNotificationSound})
			.then(res_e => {
				
				if( this.state.showIfUploaded )
					{
						this.resetChannelWaiver();
					}
					
				else
					{
						browserHistory.push("/DashboardLanding");
					}
				
			}).catch(err =>{ });
		}
		
	else
		{
			this.props.showMainErrorPop("Default Reps Time cannot be empty and cannot be higher than 200");
		}
}

updateChannelSettings=(e)=>{
	if ( this.state.selectedMenu !== 'Member Integration' )
		{
			this.updateChannelDefaultSettings();
		}
	else
		{
			if(this.state.intergrateMembers)
				{
					if ( this.state.mindBodyInfo )
						{
							var postSync = {
												channelId: this.state.mindBodyInfo.channelId,
												syncBooking: this.state.authenticateBookingsMindbody===false?0:1,
												syncClients: this.state.authenticateClientsMindbody===false?0:1,
												syncSessions: this.state.authenticateSessionsMindbody===false?0:1,
												syncStaff: this.state.authenticateStaffMindbody===false?0:1,
												responsibleAdmin: this.state.responsibleAdmin
											};
							
							$('.main_loader').attr({'style':'display: flex'});
							axios.post(process.env.REACT_APP_NAME+"/api/v1/channel/updateMindbodySettings", postSync).then(res => { 
								this.props.showMainErrorPop('Successfully updated Mindbody settings.');
								this.checkAuthInt();
							}).catch(err => {
								$('.main_loader').attr({'style':'display: none'});
								if ( err && err.response && err.response.data && err.response.data.errorData ) { this.props.showMainErrorPop(err.response.data.errorData); } else { this.props.showMainErrorPop('Something went wrong. Please try again.'); }
							});
							this.updateChannelDefaultSettings(true);
						}
					else
						{
							this.props.showMainErrorPop('Please first Authenticate Mindbody.');
						}
				}
				
			else
				{
					this.updateChannelDefaultSettings();
				}
			
		}
	
}

resetChannelWaiver=()=>{
	axios.post(process.env.REACT_APP_NAME+"/api/v1/channel/resetChannelWaiver",{"channel_id": JSON.parse(localStorage.getItem('userData')).data.responseData.channel})
	.then(res_e => {
		browserHistory.push("/DashboardLanding");
	}).catch(err =>{ });
}

openPreviews=(pg)=>{
	let mainUrl = '';
	if ( pg === 'channel' )
		{
			mainUrl = 'https://'+this.state.fullsubdomain + "/#"+btoa(JSON.stringify({backroundColorPick: this.state.backroundColorPick, fontColorPick: this.state.fontColorPick, fontTitleColorPick: this.state.fontTitleColorPick, buttonsColorPick: this.state.buttonsColorPick, highlightColorPick: this.state.highlightColorPick, searchBackground: this.state.searchBackground, searchFont: this.state.searchFont, searchInputBackground: this.state.searchInputBackground, searchInputBorder: this.state.searchInputBorder, chosenOptionColor: this.state.chosenOptionColor,activeTabColor: this.state.activeTabColor,dateHolderColor: this.state.dateHolderColor, buttonsTextColor: this.state.buttonsTextColor }));
		}
	else
		{
			mainUrl = 'https://'+this.state.fullsubdomaininvite + "/#"+btoa(JSON.stringify({backroundColorPick: this.state.backroundColorPick, fontColorPick: this.state.fontColorPick, fontTitleColorPick: this.state.fontTitleColorPick, buttonsColorPick: this.state.buttonsColorPick, highlightColorPick: this.state.highlightColorPick, chosenOptionColor: this.state.chosenOptionColor,buttonsTextColor: this.state.buttonsTextColor}));
		}
	
	window.open(mainUrl);
}

getFaq=(e)=>{
	 axios.post(process.env.REACT_APP_NAME+"/api/v1/user/getFaqsById", {id: e})          
	.then(res => {
		if(e == 13)
			{
				this.setState({mainFaqs: res.data.responseData}, ()=>{this.props.showMainErrorPop(this.state.mainFaqs, true)});
			}
			
		else
			{
				this.setState({mainFaqs: res.data.responseData}, ()=>{this.props.showMainErrorPop(this.state.mainFaqs)});
			}
	})
	.catch(err =>{ });  
}

openMenu=(pg)=>{
	
	if ( pg == 'Channel Page Customization' )
		{
			if ( this.state.channelMainData.subdomain && this.state.channelMainData.subdomain !== ''  )
				{
					this.setState({selectedMenu: pg});
					
				}
			else 
				{
					this.props.showMainErrorPop('Please generate Channel Page first');
				}				
		}
	else 
		{
			this.setState({selectedMenu: pg});
		}		
	
}

openSubMenu=(pg)=>{
	this.setState({submenuExternal: pg});
}



authenticateMindbody=()=>{
	var clientsMind = this.state.authenticateClientsMindbody;
	clientsMind = !clientsMind;
	this.setState({authenticateClientsMindbody: clientsMind});
}

authenticateCsi=()=>{
	var clientsCsi = this.state.authenticateClientsCSI;
	clientsCsi = !clientsCsi;
	this.setState({authenticateClientsCSI: clientsCsi});
}

openMindbodyPop=()=>{
	$('#mindbodyIntegrate').attr({'style':'display:block'});
	this.setState({usernameMindbody: '', passwordMindbody: '', siteIdMindbody: ''});
}

validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

autheniticateMindbody=()=>{
	if ( this.state.usernameMindbody === '' || this.state.passwordMindbody === '' || this.state.siteIdMindbody === '' )
		{
			this.props.showMainErrorPop('Please enter valid Mindbody informations.');
			return false;
		}
		
		
	$('.main_loader').attr({'style':'display:flex'});
	let postdata = {
						channelId: JSON.parse(localStorage.getItem('userData')).data.responseData.channel,
						'username': this.state.usernameMindbody,
						'password': this.state.passwordMindbody,
						'siteId': this.state.siteIdMindbody,
						'importClients': this.state.authenticateClientsMindbody,
						'importStaff': this.state.authenticateStaffMindbody,
						'importSessions': this.state.authenticateSessionsMindbody,
						'importBookings': this.state.authenticateBookingsMindbody
					};
	
	
	
	// let postdata = {'username': 'Siteowner', 'password': 'apitest1234', 'siteId': '-99', , 'importAllClients': true};
	
	console.log(postdata);
	axios.post(process.env.REACT_APP_NAME+"/api/v1/mindbody/firstRunMindbody", postdata).then(res => { 
		
		this.props.showMainErrorPop('Successfully authorized.');
		$('#mindbodyIntegrate').attr({'style':'display: none'});
		
		this.checkAuthInt();
		
	}).catch(err => {
		$('.main_loader').attr({'style':'display: none'});
		if ( err && err.response && err.response.data && err.response.data.errorData ) { this.props.showMainErrorPop(err.response.data.errorData); } else { this.props.showMainErrorPop('Something went wrong. Please try again.'); }
		
	});
}

removeMindbody=()=>{
	
	$('.main_loader').attr({'style':'display:flex'});
	axios.post(process.env.REACT_APP_NAME+"/api/v1/mindbody/removeMindbody", {channelId: JSON.parse(localStorage.getItem('userData')).data.responseData.channel}).then(res => { 
		
		this.props.showMainErrorPop('Successfully removed.');
		this.checkAuthInt();
		
	}).catch(err => { $('.main_loader').attr({'style':'display: none'}); });
}

autheniticateCSI=()=>{
	if ( parseInt(this.state.memberNum) > 0 )
		{
			$('.main_loader').attr({'style':'display:flex'});
			var postdata = {memberNumber: this.state.memberNum, authenticateClientsCSI: this.state.authenticateClientsCSI, channelId: JSON.parse(localStorage.getItem('userData')).data.responseData.channel};
			axios.post(process.env.REACT_APP_NAME+"/api/v1/mindbody/firstRunCSI", postdata).then(res => { 
				this.props.showMainErrorPop('Successfully imported your Clients from CSI as Channel members.');
				$('.main_loader').attr({'style':'display: none'});
				$('#csiIntegrate').attr({'style':'display:none'});
				this.setState({memberNum: 0});
			}).catch(err => {
				$('.main_loader').attr({'style':'display: none'});
				$('#csiIntegrate').attr({'style':'display:none'});
				if ( err && err.response && err.response.data && err.response.data.errorData ) { this.props.showMainErrorPop(err.response.data.errorData); } else { this.props.showMainErrorPop('Something went wrong. Please try again.'); }
				this.setState({memberNum: 0});
			});
		}
	else
		{
			this.props.showMainErrorPop('Please enter valid Member number.');
		}
}


openCSIPop=()=>{
	$('#csiIntegrate').attr({'style':'display:block'});
	this.setState({usernameCSI: '', passwordCSI: ''});
}

onChange1 = date =>
{
  //2019-10-20
  const month = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC']
  let getFullYear=new Date(date).getFullYear();
  let getMonth=month[(new Date(date).getMonth())];
  let getDate=new Date(date).getDate();
 // console.log(getFullYear+'-'+getMonth+'-'+getDate,'--------------',new Date(date).getFullYear(),new Date(date).getDate(),new Date(date).getMonth());
//let sessionDate =new Date(this.state.when).getDate()+'-'++''new Date(this.state.when).getDate() 
this.setState({
  sessionCalender: date,
})
}

removeWatermark=()=>{
	this.setState({ 
		watermark_image: null,
		showWatermark: false
	});
}

sessionDate=(e)=>{
	console.log('CHANGE DATEEEEEEEEEEEE');
	console.log(this.state.sessionCalender);

	let endDateWaiver = moment(this.state.sessionCalender).format('YYYY-MM-DD');
	let endDateWaiverTextFormat = moment(this.state.sessionCalender).format('MMM D, YYYY');

	
	this.setState({
		endDate:endDateWaiver,
		whenSessionTime:endDateWaiverTextFormat,
	},()=>{{$("#calenderModel").attr({'style':'display:none'}); 
	  
		console.log('------timee1----------',this.state.endDate);		
		console.log('------timee2----------',this.state.whenSessionTime);		
	}})
  
}

openInfoPopUpNew = (e, mod) => {
	if(mod == 'over')
		{
			e.stopPropagation(); 
			$('.tooltip_hold').removeClass('tooltip_active2');
			$(e.currentTarget).find('.tooltip_hold').addClass('tooltip_active2');
		}
		
	else
		{
			e.stopPropagation(); 
			$('.tooltip_hold').removeClass('tooltip_active2');
		}
}

openColorInp=(mod)=>{
	let inpId = '#'+mod;
	$(inpId).trigger('click');
}

  render() {
    return (
		<div className="container-fluid custom-width">
			<Header loginName={this.state.loginName} totalSession={this.state.totalSession} fullsubdomain={this.state.fullsubdomain}></Header>
			<div className="my_profile_inner_container channel_settings_container" className={"my_profile_inner_container channel_settings_container " + (this.state.selectedMenu === 'Channel Page Customization' ? 'ch_scroll_y_Active' : '')}>
				<div className="repoorts_main_title">Channel Settings <img src="/images/bulb.png" className="ml-3 mb-2 cursor-pointer manage_bulb channel_settings_bulb" onClick={e=>{this.getFaq(13)}}/></div>
				<Link to ="DashboardLanding"><div className="closePopup settings_close_popup channel_settings_close"></div></Link>
				<div className="channel_settings_menu">
					<div className={"one_settings_title " + (this.state.selectedMenu === 'Member Integration' ? 'active' : '')} onClick={() => this.openMenu('Member Integration')}><span className="relative">Member Integration{ this.state.selectedMenu === 'Member Integration' && <div className="abs_border_ch"></div>}</span></div>
					<div className={"one_settings_title " + (this.state.selectedMenu === 'Channel Page Customization' ? 'active' : '')} onClick={() => this.openMenu('Channel Page Customization')}><span className="relative">Channel Page Customization{ this.state.selectedMenu === 'Channel Page Customization' && <div className="abs_border_ch"></div>}</span></div>
					<div className={"one_settings_title " + (this.state.selectedMenu === 'Channel Settings' ? 'active' : '')} onClick={() => this.openMenu('Channel Settings')}><span className="relative">Channel Settings{ this.state.selectedMenu === 'Channel Settings' && <div className="abs_border_ch"></div>}</span></div>
					<div className={"one_settings_title " + (this.state.selectedMenu === 'External API' ? 'active' : '')} onClick={() => this.openMenu('External API')}><span className="relative">External API{ this.state.selectedMenu === 'External API' && <div className="abs_border_ch"></div>}</span></div>
				</div>
				{ this.state.selectedMenu === 'Member Integration' &&
					<div>
						<div className="channel_session_default channel_layout bord_none pb0">
							<div className="default_channel_session customize_title w100 pb7 title_border create_virdio_user_hold">
								<div className="default_channel_title integration_title">Create Virdio User When Importing Members</div>
								<label className="switch create_user_switch"><input type="checkbox" id = "channelCreateUser" checked={this.state.channelCreateUser} onChange = {(e)=>{this.updateStateMember({[e.target.id]: !this.state[e.target.id]})}}/><span className="slider round"></span></label><div className="toggle_option">{this.state.channelCreateUser ? 'ON' : 'OFF'}</div>
								<img src="/images/bulb.png" onClick={e=>{this.props.showMainErrorPop('Create Virdio User When Importing Members.')}} className="ml-3 mb-2 cursor-pointer channel_bulb"/>
							</div>
							{this.state.channelCreateUser &&
								<div className="one_authenicate">
									<div className="form-group email_channel_settings"><span className="cover-border"></span>
										<label className="label">Email Message *</label>
										<textarea type="text" 
											id ="emailMessage"
											value = {this.state.emailMessage}
											onChange={(e)=>this.setState({[e.target.id]:e.target.value})}
											className="input-field">
										</textarea>
									</div> 
								</div>
							}
							
							<div className="default_channel_session customize_title w100 title_border pb7">
								<div className="default_channel_title integration_title">Integrating with Mindbody</div>
								<label className="switch"><input type="checkbox" id="intergrateMembers" checked={this.state.intergrateMembers} onChange = {(e)=>{this.updateStateIntegration({[e.target.id]: !this.state[e.target.id]})}}/><span className="slider round"></span></label><div className="toggle_option">{this.state.intergrateMembers ? 'ON' : 'OFF'}</div>
							</div>
							{this.state.intergrateMembers &&
								<div className="one_authenicate">
									{ !this.state.mindBodyInfo ? <div className="join_button auth_btn" onClick={this.openMindbodyPop}>Authenticate</div>
									:
										<div className="default_channel_title">Username: {this.state.mindBodyInfo.apiUsername}<br />Site Id: {this.state.mindBodyInfo.apiId}<br /><div className="join_button auth_btn" onClick={this.removeMindbody}>Remove</div></div>
									}
									
									
									<div className="main_settings_holder mobileclear channel_settings_choose for_auth_cbx">
										<span className="main_settings_text">Automatically Synchronize Clients</span>
										<label className="switch"><input type="checkbox" id="authenticateClientsMindbody" checked={this.state.authenticateClientsMindbody} onChange = {(e)=>{this.updateState({[e.target.id]: !this.state[e.target.id]})}}/><span className="slider round"></span></label>
										<div className="toggle_option">{this.state.authenticateClientsMindbody ? 'ON' : 'OFF'}</div>
									</div>
									
									<div className="main_settings_holder mobileclear channel_settings_choose for_auth_cbx">
										<span className="main_settings_text">Automatically Synchronize Staff / Instructors</span>
										<label className="switch"><input type="checkbox" id="authenticateStaffMindbody" checked={this.state.authenticateStaffMindbody} onChange = {(e)=>{this.updateState({[e.target.id]: !this.state[e.target.id]})}}/><span className="slider round"></span></label>
										<div className="toggle_option">{this.state.authenticateStaffMindbody ? 'ON' : 'OFF'}</div>
									</div>
									
									<div className="main_settings_holder mobileclear channel_settings_choose for_auth_cbx">
										<span className="main_settings_text">Automatically Synchronize Classes</span>
										<label className="switch"><input type="checkbox" id="authenticateSessionsMindbody" checked={this.state.authenticateSessionsMindbody} onChange = {(e)=>{this.updateState({[e.target.id]: !this.state[e.target.id]})}}/><span className="slider round"></span></label>
										<div className="toggle_option">{this.state.authenticateSessionsMindbody ? 'ON' : 'OFF'}</div>
									</div>
									
									<div className="main_settings_holder mobileclear channel_settings_choose for_auth_cbx">
										<span className="main_settings_text">Automatically Synchronize Bookings</span>
										<label className="switch"><input type="checkbox" id="authenticateBookingsMindbody" checked={this.state.authenticateBookingsMindbody} onChange = {(e)=>{this.updateState({[e.target.id]: !this.state[e.target.id]})}}/><span className="slider round"></span></label>
										<div className="toggle_option">{this.state.authenticateBookingsMindbody ? 'ON' : 'OFF'}</div>
									</div>
									
									<div className="one_authenicate">
										<div className="form-group email_channel_settings"><span className="cover-border"></span>
											<label className="label">Email Message for Mindbody Clients</label>
											<textarea type="text" 
												id ="emailMessageMindbody"
												value = {this.state.emailMessageMindbody}
												onChange={(e)=>this.setState({[e.target.id]:e.target.value})}
												className="input-field">
											</textarea>
										</div> 
									</div>
									<div className="one_authenicate">
										<div className="resp_title">Responsible Admin</div>
										<div className="drop_admins" onClick={this.openHostsDrop}>{ this.state.responsibleAdmin > 0 ? this.state.reponsibleAdminName : 'None' }
											{ this.state.isOpenHostsDrop &&
												<div className="hosts_drop" onClick={(e) => this.preventDef(e)}>
													{ this.state.hostsArray.sort(function(a, b){ if(a.username < b.username) { return -1; } if(a.username > b.username) { return 1; } return 0; }).map((item, key) => 
														<div key={key}>
															{ item.is_admin === 1 &&
																<div className="one_host_mind">{item.username}
																	<div className={"review_cbx hosts_cbx " + (this.state.responsibleAdmin === item.userId ? 'active' : '')} onClick={() => this.selectHost(item)}></div>
																</div>
															}
														</div>
													)}
												</div>
											}
										</div>
									</div>
								</div>
							}
						</div>
						
						<div className="channel_session_default channel_layout bord_none pb0 integrating_csi">
							<div className="default_channel_session customize_title w100 title_border pb7">
								<div className="default_channel_title integration_title">Integrating with CSI</div>
								<label className="switch"><input type="checkbox" id="csiIntegration" checked={this.state.csiIntegration} onChange = {(e)=>{this.updateStateCsi({[e.target.id]: !this.state[e.target.id]})}}/><span className="slider round"></span></label><div className="toggle_option">{this.state.csiIntegration ? 'ON' : 'OFF'}</div>
							</div>
							{this.state.csiIntegration &&
								<div className="one_authenicate">
									<div className="join_button auth_btn" onClick={this.openCSIPop}>Authenticate</div>
									<div className="main_settings_holder mobileclear channel_settings_choose for_auth_cbx">
										<span className="main_settings_text">Automatically Synchronize Clients</span>
										<label className="switch"><input type="checkbox" id="authenticateClientsCSI" checked={this.state.authenticateClientsCSI} onChange = {(e)=>{this.updateState({[e.target.id]: !this.state[e.target.id]})}}/><span className="slider round"></span></label>
										<div className="toggle_option">{this.state.authenticateClientsCSI ? 'ON' : 'OFF'}</div>
									</div>
								</div>
							}
						</div>  
					</div>
				}
				{ this.state.selectedMenu === 'Channel Settings' &&
					<div>
						<div className="channel_session_default">
							<div className="default_channel_session">
								<div className="default_channel_title">Channel Class Defaults</div>
							</div>
							<div className="default_channel_session channel_allow_host_hold">
								<div className="default_channel_title allow_host_title">Allow Instructor to Change Settings</div>
							</div>
						</div>
						<div className="channel_settings_allow_hold">
							<div className="main_settings_holder mobileclear channel_settings_choose">
								<div className="channel_hold_settings">
									<span className="main_settings_text">Public Class</span>
									<div className="toggle_option toggle_option_right">{this.state.sessionProperty ? 'ON' : 'OFF'}</div>
									<label className="switch">
										<input type="checkbox" id = "sessionProperty" checked={this.state.sessionProperty} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.sessionProperty})}}/>
										<span className="slider round"></span>
									</label>
									
									<img src="/images/bulb.png" onClick={e=>{this.props.showMainErrorPop('Public Classes allow anyone with the link to sign up for the Class.  To attend a Class that is set to Private, the Member must be a Member of your Channel.')}} className="ml-3 mb-2 cursor-pointer channel_bulb"/>
								</div>
								<div className="channel_hold_settings allow_hold_settings">
									<div className="channel_switch_hold">
										<div className="toggle_option toggle_option_right">{this.state.allowSessionProperty ? 'ON' : 'OFF'}</div>
										<label className="switch">
											<input type="checkbox" id = "allowSessionProperty"  checked={this.state.allowSessionProperty} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.allowSessionProperty})}}/>
											<span className="slider round"></span>
										</label>
										
									</div>
								</div>
							</div>
							<div className="main_settings_holder mobileclear channel_settings_choose">
								<div className="channel_hold_settings">
									<span className="main_settings_text">Publish on Channel Page</span>
									<div className="toggle_option toggle_option_right">{this.state.sessionPublishPage ? 'ON' : 'OFF'}</div>
									<label className="switch">
										<input type="checkbox" id = "sessionPublishPage" checked={this.state.sessionPublishPage} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.sessionPublishPage})}}/>
										<span className="slider round"></span>
									</label>
									
									<img src="/images/bulb.png" className="ml-3 mb-2 cursor-pointer channel_bulb" onClick={e=>{this.props.showMainErrorPop('If you want Members to sign up or join the class from your channel page, set it to ON')}}/>
								</div>
								<div className="channel_hold_settings allow_hold_settings">
									<div className="channel_switch_hold">
										<div className="toggle_option toggle_option_right">{this.state.allowSessionPublicChannel ? 'ON' : 'OFF'}</div>
										<label className="switch">
											<input type="checkbox" id = "allowSessionPublicChannel" checked={this.state.allowSessionPublicChannel} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.allowSessionPublicChannel})}}/>
											<span className="slider round"></span>
										</label>
										
									</div>
								</div>
							</div>
							<div className="main_settings_holder mobileclear channel_settings_choose">
								<div className="channel_hold_settings">
									<span className="main_settings_text">Class Searchable on Marketplace</span>
									<div className="toggle_option toggle_option_right">{this.state.sessionSearchable ? 'ON' : 'OFF'}</div>
									<label className="switch">
										<input type="checkbox" id = "sessionSearchable" checked={this.state.sessionSearchable} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.sessionSearchable})}}/>
										<span className="slider round"></span>
									</label>
									
									<img src="/images/bulb.png" onClick={e=>{this.props.showMainErrorPop('If you want Members to sign up or join the class from your channel page, set it to ON. Publishing the class to your channel page will also make the class searchable on virdio.com.')}} className="ml-3 mb-2 cursor-pointer channel_bulb"/>
								</div>
								<div className="channel_hold_settings allow_hold_settings">
									<div className="channel_switch_hold">
										<div className="toggle_option toggle_option_right">{this.state.allowSessionSearchable ? 'ON' : 'OFF'}</div>
										<label className="switch">
											<input type="checkbox" id = "allowSessionSearchable" checked={this.state.allowSessionSearchable} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.allowSessionSearchable})}}/>
											<span className="slider round"></span>
										</label>
										
									</div>
								</div>						
							</div>
							<div className="main_settings_holder mobileclear channel_settings_choose">
								<div className="channel_hold_settings">
									<span className="main_settings_text">Show other Members</span>
									<div className="toggle_option toggle_option_right">{this.state.showOtherParticipants ? 'ON' : 'OFF'}</div>
									<label className="switch">
										<input type="checkbox" id = "showOtherParticipants" checked={this.state.showOtherParticipants} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.showOtherParticipants})}}/>
										<span className="slider round"></span>
									</label>
									
									<img src="/images/bulb.png" className="ml-3 mb-2 cursor-pointer channel_bulb" onClick={e=>{this.props.showMainErrorPop('If you want to allow Members to see each other in the Live classes, set it to ON.')}}/>
								</div>
								<div className="channel_hold_settings allow_hold_settings">
									<div className="channel_switch_hold">
										<div className="toggle_option toggle_option_right">{this.state.allowShowOtherParticipants ? 'ON' : 'OFF'}</div>
										<label className="switch">
											<input type="checkbox" id = "allowShowOtherParticipants" checked={this.state.allowShowOtherParticipants} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.allowShowOtherParticipants})}}/>
											<span className="slider round"></span>
										</label>
										
									</div>
								</div>
							</div>
							<div className="main_settings_holder mobileclear channel_settings_choose d-none">
								<div className="channel_hold_settings">
									<span className="main_settings_text">Switch Instructor/Member PIP</span>
									<div className="toggle_option toggle_option_right">{this.state.showHostParticipant ? 'ON' : 'OFF'}</div>
									<label className="switch">
										<input type="checkbox" id = "showHostParticipant" checked={this.state.showHostParticipant} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.showHostParticipant})}}/>
										<span className="slider round"></span>
									</label>
									
									<img src="/images/bulb.png" className="ml-3 mb-2 cursor-pointer channel_bulb" onClick={e=>{this.props.showMainErrorPop('Coming Soon.')}}/>
								</div>
								<div className="channel_hold_settings allow_hold_settings">
									<div className="channel_switch_hold">
										<div className="toggle_option toggle_option_right">{this.state.allowShowHostParticipant ? 'ON' : 'OFF'}</div>
										<label className="switch">
											<input type="checkbox" id = "allowShowHostParticipant" checked={this.state.allowShowHostParticipant} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.allowShowHostParticipant})}}/>
											<span className="slider round"></span>
										</label>
										
									</div>
								</div>
							</div>
							<div className="main_settings_holder mobileclear channel_settings_choose">
								<div className="channel_hold_settings">
									<span className="main_settings_text">Record Class & Offer On-demand</span>
									<div className="toggle_option toggle_option_right">{this.state.startRecording ? 'ON' : 'OFF'}</div>
									<label className="switch">
										<input type="checkbox" id = "startRecording"  checked={this.state.startRecording} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.startRecording})}}/>
										<span className="slider round"></span>
									</label>
									
									<img src="/images/bulb.png" className="ml-3 mb-2 cursor-pointer channel_bulb" onClick={e=>{this.props.showMainErrorPop('If you want to Record your class and offer it via On-Demand, set it to ON.')}}/>
								</div>
								<div className="channel_hold_settings allow_hold_settings">
									<div className="channel_switch_hold">
										<div className="toggle_option toggle_option_right">{this.state.allowStartRecording ? 'ON' : 'OFF'}</div>
										<label className="switch">
											<input type="checkbox" id = "allowStartRecording" checked={this.state.allowStartRecording} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.allowStartRecording})}}/>
											<span className="slider round"></span>
										</label>
										
									</div>
								</div>
							</div>
							<div className="main_settings_holder mobileclear channel_settings_choose d-none">
								<div className="channel_hold_settings">
									<span className="main_settings_text">Class Members View On-demand for 30 days free</span>
									<div className="toggle_option toggle_option_right">{this.state.sessionViewDemand ? 'ON' : 'OFF'}</div>
									<label className="switch">
										<input type="checkbox" id = "sessionViewDemand" checked={this.state.sessionViewDemand} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.sessionViewDemand})}}/>
										<span className="slider round"></span>
									</label>
									
									<img src="/images/bulb.png" className="ml-3 mb-2 cursor-pointer channel_bulb" onClick={e=>{this.props.showMainErrorPop('Coming Soon.')}}/>
								</div>
								<div className="channel_hold_settings allow_hold_settings">
									<div className="channel_switch_hold">
										<div className="toggle_option toggle_option_right">{this.state.allowSessionViewDemand ? 'ON' : 'OFF'}</div>
										<label className="switch">
											<input type="checkbox" id = "allowSessionViewDemand" checked={this.state.allowSessionViewDemand} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.allowSessionViewDemand})}}/>
											<span className="slider round"></span>
										</label>
										
									</div>
								</div>
							</div>
							<div className="main_settings_holder mobileclear channel_settings_choose">
								<div className="channel_hold_settings">
									<span className="main_settings_text">Require Members to have Camera</span>
									<div className="toggle_option toggle_option_right">{this.state.requireCamera ? 'ON' : 'OFF'}</div>
									<label className="switch">
										<input type="checkbox" id="requireCamera" checked={this.state.requireCamera} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.requireCamera})}}/>
										<span className="slider round"></span>
									</label>
									
									<img src="/images/bulb.png" className="ml-3 mb-2 cursor-pointer channel_bulb" onClick={e=>{this.props.showMainErrorPop('If you want to allow Members to attend Live classes without a camera, set it to ON.')}}/>
								</div>
								<div className="channel_hold_settings allow_hold_settings">
									<div className="channel_switch_hold">
										<div className="toggle_option toggle_option_right">{this.state.allowRequireCameraHost ? 'ON' : 'OFF'}</div>
										<label className="switch">
											<input type="checkbox" id = "allowRequireCameraHost" checked={this.state.allowRequireCameraHost} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.allowRequireCameraHost})}}/>
											<span className="slider round"></span>
										</label>
										
									</div>
								</div>
							</div>
							<div className="main_settings_holder mobileclear channel_settings_choose">
								<div className="channel_hold_settings">
									<span className="main_settings_text">Disable Notification Sound</span>
									<div className="toggle_option toggle_option_right">{this.state.disableNotificationSound ? 'ON' : 'OFF'}</div>
									<label className="switch">
										<input type="checkbox" id = "disableNotificationSound" checked={this.state.disableNotificationSound} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.disableNotificationSound})}}/>
										<span className="slider round"></span>
									</label>
									
									<img src="/images/bulb.png" className="ml-3 mb-2 cursor-pointer channel_bulb" onClick={e=>{this.props.showMainErrorPop('If you want to Disable Notification Sound in the Live classes, set it to ON.')}}/>
								</div>
								<div className="channel_hold_settings allow_hold_settings">
									<div className="channel_switch_hold">
										<div className="toggle_option toggle_option_right">{this.state.allowDisableNotificationSound ? 'ON' : 'OFF'}</div>
										<label className="switch">
											<input type="checkbox" id = "allowDisableNotificationSound" checked={this.state.allowDisableNotificationSound} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.allowDisableNotificationSound})}}/>
											<span className="slider round"></span>
										</label>
										
									</div>
								</div>
							</div>
						</div>
						<div className="form-group channel_reps_time">
							<div className="inline_bulb w80per">
								<span className="cover-border channel_settings_border"></span>
								<label className="label">Default Reps Time</label>
								<input type="number" className="input-field channel_settings_input" id="session_details" value={this.state.defaultRepsTime} onChange={e => this.updateState({defaultRepsTime: e.target.value})}/>
							</div>
							<div className="inline_bulb">
								<img src="/images/bulb.png" className="ml-3 mb-2 cursor-pointer channel_bulb" onClick={e=>{this.props.showMainErrorPop('You can set the default time for reps based activities in Workout Builder')}}/>
							</div>
						</div>
						<div className="main_settings_holder mobileclear channel_settings_choose mt50">
							<div className="channel_hold_settings">
								<span className="main_settings_text">On Channel Page first tab On-demand</span>
								<div className="toggle_option toggle_option_right">{this.state.firstTabOnDemand ? 'ON' : 'OFF'}</div>
								<label className="switch">
									<input type="checkbox" id="firstTabOnDemand" checked={this.state.firstTabOnDemand} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.firstTabOnDemand})}}/>
									<span className="slider round"></span>
								</label>
								
								<img src="/images/bulb.png" className="ml-3 mb-2 cursor-pointer channel_bulb" onClick={e=>{this.props.showMainErrorPop('Switch the tab order on Channel Page between Live Streaming Tab and On-demand Tab.')}}/>
							</div>
						</div>
						<div className="main_settings_holder mobileclear channel_settings_choose">
							<div className="channel_hold_settings">
								<span className="main_settings_text">Show Live Classes Tab</span>
								<div className="toggle_option toggle_option_right">{this.state.showLiveTab ? 'ON' : 'OFF'}</div>
								<label className="switch">
									<input type="checkbox" id="showLiveTab" checked={this.state.showLiveTab} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.showLiveTab})}}/>
									<span className="slider round"></span>
								</label>
							</div>
						</div>
						<div className="main_settings_holder mobileclear channel_settings_choose">
							<div className="channel_hold_settings">
								<span className="main_settings_text">Show On-Demand Classes Tab</span>
								<div className="toggle_option toggle_option_right">{this.state.showOndemandTab ? 'ON' : 'OFF'}</div>
								<label className="switch">
									<input type="checkbox" id="showOndemandTab" checked={this.state.showOndemandTab} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.showOndemandTab})}}/>
									<span className="slider round"></span>
								</label>
							</div>
						</div>
						<div className="main_settings_holder mobileclear channel_settings_choose">
							<div className="channel_hold_settings watermark_section">
								<span className="main_settings_text">On-demand Recording Watermark</span>
								<div className="toggle_option toggle_option_right">{this.state.showWatermark ? 'ON' : 'OFF'}</div>
								<label className="switch">
									<input type="checkbox" id="showWatermark" checked={this.state.showWatermark} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.showWatermark})}}/>
									<span className="slider round"></span>
								</label>
								
								<img src="/images/bulb.png" className="ml-3 mb-2 cursor-pointer channel_bulb d-none" onClick={e=>{this.props.showMainErrorPop('Add a watermark.')}}/>
							</div>
							<div className="channel_hold_settings allow_hold_settings">
								{this.state.showWatermark &&
									<div className="form-group sessionselectimage channel_select_image">				
										<span className="cover-border"></span>
										<label className="label">Watermark</label>														
										<div className="custom-file-session">
											<img src={!this.state.watermark_image ? "/images/browse-image.png ": this.state.watermark_image} className="browse_image" alt="" />
											<input type="file" className="custom-file-input" id="customFile_imgs" name="file" onChange={ (e) => { this.changeWatermark(e) }} />
										</div>
										{this.state.watermark_image &&
											<div className="waiver_doc_uploaded pointer" onClick={()=>{ this.removeWatermark() }}>Remove Watermark</div>
										}
									</div>
								}
							</div>
						</div>
						
						<div className="channel_hold_settings watermark_section">
							<span className="main_settings_text">Waivers for Members</span>
							<div className="toggle_option toggle_option_right">{this.state.showWaiver ? 'ON' : 'OFF'}</div>
							<label className="switch">
								<input type="checkbox" id="showWaiver" checked={this.state.showWaiver} onChange = {(e)=>{this.updateState({[e.target.id]:!this.state.showWaiver})}}/>
								<span className="slider round"></span>
							</label>
							
							<img src="/images/bulb.png" className="ml-3 mb-2 cursor-pointer channel_bulb" onClick={e=>{this.props.showMainErrorPop('Allow Waivers for Members')}}/>
						</div>
						<div className="channel_hold_settings allow_hold_settings waiver_section">
							{this.state.showWaiver &&
								<div className="form-group sessionselectimage channel_select_image">				
									<span className="cover-border"></span>
									<label className="label">Waiver</label>														
									<div className="custom-file-session">
										<img src="/images/browse-pdf.png" className="browse_image" alt="" />
										<input type="file" accept="application/pdf" className="custom-file-input" id="customFile_imgs" name="file" onChange={ (e) => { this.changeWaiver(e) }} />
									</div>
									{this.state.showIfUploaded &&
										<div className="waiver_doc_uploaded">Waiver Document Uploaded</div>
									}
									{ this.state.waiver_pdf != null && this.state.waiverShowLink !== null && this.state.waiverShowLink !== '' &&
										<a href={this.state.waiverShowLink} target="_blank" rel="noopener noreferrer" className="waiver_doc_uploaded pointer">View Waiver Document</a>
									}
									<div className="form-group settings_end_date" >
										<div onClick={e=>{$("#calenderModel").attr({'style':'display:block'});}}>
										  <span className="cover-border"></span>
										  <label className="label">End Date<sup>*</sup></label>
										  <input type="text" id = "endDate" value = {this.state.whenSessionTime} onChange = {this.props.sessionInfo} className="input-field" placeholder="Pick an End Date" readOnly/>
										  <div className="when-icon" ></div>
										</div>
									</div>
								</div>
							}
						</div>
					</div>
				}
				<div className={(this.state.selectedMenu !== 'External API' ? "d-none" : "") }>
					<div className="channel_settings_menu">
						<div className={"one_settings_title submenu_titles " + (this.state.submenuExternal === 'External API' ? 'active' : '')} onClick={() => this.openSubMenu('External API')}><span className="relative">External API{ this.state.submenuExternal === 'External API' && <div className="abs_border_ch"></div>}</span></div>
						<div className={"one_settings_title submenu_titles " + (this.state.submenuExternal === 'Iframe' ? 'active' : '')} onClick={() => this.openSubMenu('Iframe')}><span className="relative">Embed Iframe{ this.state.submenuExternal === 'Iframe' && <div className="abs_border_ch"></div>}</span></div>
					</div>
					<div className={(this.state.submenuExternal !== 'External API' ? "d-none" : "") }>
						<TokenSetup channelId={JSON.parse(localStorage.getItem('userData')).data.responseData.channel}></TokenSetup>
					</div>
					{ this.state.submenuExternal === 'Iframe' &&
						<EmbedSubdomain channelSubdomain={this.state.fullsubdomain} subdomain={this.state.subdomain}></EmbedSubdomain>
					}
				</div>
				{ this.state.selectedMenu === 'Channel Page Customization' &&
					<div>
						<div className="channel_session_default channel_layout">
							<div className="default_channel_session customize_title">
								<div className="default_channel_title">Customize Channel Page & Channel Sign Up Page</div>
							</div>
						</div>
						<div className="channelPreviewImgHolder" >
								<div className="inputHolderAbs" style={{ backgroundColor: this.state.fontTitleColorPick }} onMouseOver={ (e) => this.openInfoPopUpNew(e, 'over') } onMouseLeave={ (e) => this.openInfoPopUpNew(e, 'leave') } >
									<div className="divHoldColor" onClick={(e) => this.openColorInp('fontTitleColorPick')}>
										<input type="color" className="inputChannelChangeColor" value={this.state.fontTitleColorPick} id="fontTitleColorPick" onChange={e => this.updateState({fontTitleColorPick: e.target.value})} />
									</div>
									<div className="tooltip_hold pink_info more_top_pos">
										<div className="tooltip_text">Top Header Color</div>
									</div>
								</div>
								<div className="inputHolderAbs bgPos" style={{ backgroundColor: this.state.backroundColorPick }} onMouseOver={ (e) => this.openInfoPopUpNew(e, 'over') } onMouseLeave={ (e) => this.openInfoPopUpNew(e, 'leave') } >
									<div className="divHoldColor bckBorder" onClick={(e) => this.openColorInp('backroundColorPick')}>
										<input type="color" className="inputChannelChangeColor" value={this.state.backroundColorPick} id="backroundColorPick" onChange={e => this.updateState({backroundColorPick: e.target.value})} />
									</div>
									<div className="tooltip_hold pink_info more_top_pos">
										<div className="tooltip_text">Background Color</div>
									</div>
								</div>
								<div className="inputHolderAbs tabPos" style={{ backgroundColor: this.state.activeTabColor }} onMouseOver={ (e) => this.openInfoPopUpNew(e, 'over') } onMouseLeave={ (e) => this.openInfoPopUpNew(e, 'leave') }>
									<div className="divHoldColor" onClick={(e) => this.openColorInp('activeTabColor')}>
										<input type="color" className="inputChannelChangeColor" value={this.state.activeTabColor} id="activeTabColor" onChange={e => this.updateState({activeTabColor: e.target.value})} />							
									</div>
									<div className="tooltip_hold pink_info more_top_pos">
										<div className="tooltip_text">Active Tab Color</div>
									</div>
								</div>
								<div className="inputHolderAbs inpSearchPos" style={{ backgroundColor: this.state.searchInputBackground }} onMouseOver={ (e) => this.openInfoPopUpNew(e, 'over') } onMouseLeave={ (e) => this.openInfoPopUpNew(e, 'leave') }>
									<div className="divHoldColor" onClick={(e) => this.openColorInp('searchInputBackground')}>
										<input type="color" className="inputChannelChangeColor" value={this.state.searchInputBackground} id="searchInputBackground" onChange={e => this.updateState({searchInputBackground: e.target.value})} />
									</div>
									<div className="tooltip_hold pink_info more_top_pos">
										<div className="tooltip_text">Search Input Background</div>
									</div>
								</div>
								<div className="inputHolderAbs searchFontPos" style={{ backgroundColor: this.state.searchFont }} onMouseOver={ (e) => this.openInfoPopUpNew(e, 'over') } onMouseLeave={ (e) => this.openInfoPopUpNew(e, 'leave') }>
									<div className="divHoldColor" onClick={(e) => this.openColorInp('searchFont')}>
										<input type="color" className="inputChannelChangeColor" value={this.state.searchFont} id="searchFont" onChange={e => this.updateState({searchFont: e.target.value})} />
									</div>
									<div className="tooltip_hold pink_info more_top_pos">
										<div className="tooltip_text">Search Font Color</div>
									</div>
								</div>
								<div className="inputHolderAbs searchBorderPos" style={{ backgroundColor: this.state.searchInputBorder }} onMouseOver={ (e) => this.openInfoPopUpNew(e, 'over') } onMouseLeave={ (e) => this.openInfoPopUpNew(e, 'leave') }>
									<div className="divHoldColor" onClick={(e) => this.openColorInp('searchInputBorder')}>
										<input type="color" className="inputChannelChangeColor" value={this.state.searchInputBorder} id="searchInputBorder" onChange={e => this.updateState({searchInputBorder: e.target.value})} />
									</div>
									<div className="tooltip_hold pink_info more_top_pos">
										<div className="tooltip_text">Search Input Border</div>
									</div>
								</div>
								<div className="inputHolderAbs searchPos" style={{ backgroundColor: this.state.searchBackground }} onMouseOver={ (e) => this.openInfoPopUpNew(e, 'over') } onMouseLeave={ (e) => this.openInfoPopUpNew(e, 'leave') }>
									<div className="divHoldColor" onClick={(e) => this.openColorInp('searchBackground')}>
										<input type="color" className="inputChannelChangeColor" value={this.state.searchBackground} id="searchBackground" onChange={e => this.updateState({searchBackground: e.target.value})} />
									</div>
									<div className="tooltip_hold pink_info more_top_pos">
										<div className="tooltip_text">Search Background</div>
									</div>
								</div>
								<div className="inputHolderAbs dateHoldPos" style={{ backgroundColor: this.state.dateHolderColor }} onMouseOver={ (e) => this.openInfoPopUpNew(e, 'over') } onMouseLeave={ (e) => this.openInfoPopUpNew(e, 'leave') }>
									<div className="divHoldColor" onClick={(e) => this.openColorInp('dateHolderColor')}>
										<input type="color" className="inputChannelChangeColor" value={this.state.dateHolderColor} id="dateHolderColor" onChange={e => this.updateState({dateHolderColor: e.target.value})} />
									</div>
									<div className="tooltip_hold pink_info more_top_pos">
										<div className="tooltip_text">Date Holder Color</div>
									</div>
								</div>
								<div className="inputHolderAbs fontColPos" style={{ backgroundColor: this.state.fontColorPick }} onMouseOver={ (e) => this.openInfoPopUpNew(e, 'over') } onMouseLeave={ (e) => this.openInfoPopUpNew(e, 'leave') }>
									<div className="divHoldColor" onClick={(e) => this.openColorInp('fontColorPick')}>
										<input type="color" className="inputChannelChangeColor" value={this.state.fontColorPick} id="fontColorPick" onChange={e => this.updateState({fontColorPick: e.target.value})} />
									</div>
									<div className="tooltip_hold pink_info more_top_pos">
										<div className="tooltip_text">Font Color</div>
									</div>
								</div>
								<div className="inputHolderAbs highColPos" style={{ backgroundColor: this.state.highlightColorPick }} onMouseOver={ (e) => this.openInfoPopUpNew(e, 'over') } onMouseLeave={ (e) => this.openInfoPopUpNew(e, 'leave') }>
									<div className="divHoldColor" onClick={(e) => this.openColorInp('highlightColorPick')}>
										<input type="color" className="inputChannelChangeColor" value={this.state.highlightColorPick} id="highlightColorPick" onChange={e => this.updateState({highlightColorPick: e.target.value})} />
									</div>
									<div className="tooltip_hold pink_info more_top_pos">
										<div className="tooltip_text">Highlight Text Color</div>
									</div>
								</div>
								<div className="inputHolderAbs btnColPos" style={{ backgroundColor: this.state.buttonsColorPick }} onMouseOver={ (e) => this.openInfoPopUpNew(e, 'over') } onMouseLeave={ (e) => this.openInfoPopUpNew(e, 'leave') }>
									<div className="divHoldColor" onClick={(e) => this.openColorInp('buttonsColorPick')}>
										<input type="color" className="inputChannelChangeColor" value={this.state.buttonsColorPick} id="buttonsColorPick" onChange={e => this.updateState({buttonsColorPick: e.target.value})} />
									</div>
									<div className="tooltip_hold pink_info more_top_pos">
										<div className="tooltip_text">Buttons Color</div>
									</div>
								</div>
								<div className="inputHolderAbs btnTextColPos" style={{ backgroundColor: this.state.buttonsTextColor }} onMouseOver={ (e) => this.openInfoPopUpNew(e, 'over') } onMouseLeave={ (e) => this.openInfoPopUpNew(e, 'leave') }>
									<div className="divHoldColor" onClick={(e) => this.openColorInp('buttonsTextColor')}>
										<input type="color" className="inputChannelChangeColor" value={this.state.buttonsTextColor} id="buttonsTextColor" onChange={e => this.updateState({buttonsTextColor: e.target.value})} />
									</div>
									<div className="tooltip_hold pink_info more_top_pos">
										<div className="tooltip_text">Buttons Text Color</div>
									</div>
								</div>
								<div className="inputHolderAbs radioColPos" style={{ backgroundColor: this.state.chosenOptionColor }} onMouseOver={ (e) => this.openInfoPopUpNew(e, 'over') } onMouseLeave={ (e) => this.openInfoPopUpNew(e, 'leave') }>
									<div className="divHoldColor" onClick={(e) => this.openColorInp('chosenOptionColor')}>
										<input type="color" className="inputChannelChangeColor" value={this.state.chosenOptionColor} id="chosenOptionColor" onChange={e => this.updateState({chosenOptionColor: e.target.value})} />
									</div>
									<div className="tooltip_hold pink_info more_top_pos">
										<div className="tooltip_text">Radio Button Color</div>
									</div>
								</div>
								
						</div>
						
						{/*
						<div className="color_picker_hold">
							<div className="text-left">
								<input type="color" className="color_picker_input"value={this.state.fontTitleColorPick} id="fontTitleColorPick" onChange={e => this.updateState({fontTitleColorPick: e.target.value})} />
								<div className="color_option_title">Top Header Color</div>
							</div>
						</div>
						<div className="color_picker_hold">
							<div className="color_picker_side">
								<input type="color" className="color_picker_input"value={this.state.backroundColorPick} id="backroundColorPick" onChange={e => this.updateState({backroundColorPick: e.target.value})} />
								<div className="color_option_title">Background Color</div>
							</div>
							<div className="color_picker_side">
								<input type="color" className="color_picker_input"value={this.state.fontColorPick} id="fontColorPick" onChange={e => this.updateState({fontColorPick: e.target.value})} />
								<div className="color_option_title">Font Color</div>
							</div>
							<div className="color_picker_side">
								<input type="color" className="color_picker_input" value={this.state.buttonsColorPick} id="buttonsColorPick" onChange={e => this.updateState({buttonsColorPick: e.target.value})} />
								<div className="color_option_title">Buttons Color</div>
							</div>
							<div className="color_picker_side">
								<input type="color" className="color_picker_input" value={this.state.highlightColorPick} id="highlightColorPick" onChange={e => this.updateState({highlightColorPick: e.target.value})} />
								<div className="color_option_title">Highlight Text Color</div>
							</div>
							<div className="search_color_hold">
								<div className="color_picker_side">
									<input type="color" className="color_picker_input" value={this.state.searchBackground} id="searchBackground" onChange={e => this.updateState({searchBackground: e.target.value})} />
									<div className="color_option_title">Search Background</div>
								</div>
								<div className="color_picker_side">
									<input type="color" className="color_picker_input" value={this.state.searchFont} id="searchFont" onChange={e => this.updateState({searchFont: e.target.value})} />
									<div className="color_option_title">Search Font Color</div>
								</div>
								<div className="color_picker_side">
									<input type="color" className="color_picker_input" value={this.state.searchInputBackground} id="searchInputBackground" onChange={e => this.updateState({searchInputBackground: e.target.value})} />
									<div className="color_option_title">Search Input Background</div>
								</div>
								<div className="color_picker_side">
									<input type="color" className="color_picker_input" value={this.state.searchInputBorder} id="searchInputBorder" onChange={e => this.updateState({searchInputBorder: e.target.value})} />
									<div className="color_option_title">Search Input Border</div>
								</div>
							</div>
							<div className="search_color_hold leftSidePickers" >
								<div className="color_picker_side">
									<input type="color" className="color_picker_input" value={this.state.buttonsTextColor} id="buttonsTextColor" onChange={e => this.updateState({buttonsTextColor: e.target.value})} />
									<div className="color_option_title">Buttons Text Color</div>
								</div>
								<div className="color_picker_side">
									<input type="color" className="color_picker_input" value={this.state.activeTabColor} id="activeTabColor" onChange={e => this.updateState({activeTabColor: e.target.value})} />
									<div className="color_option_title">Active Tab Color</div>
								</div>
								<div className="color_picker_side">
									<input type="color" className="color_picker_input" value={this.state.dateHolderColor} id="dateHolderColor" onChange={e => this.updateState({dateHolderColor: e.target.value})} />
									<div className="color_option_title">Date Holder Color</div>
								</div>
								<div className="color_picker_side">
									<input type="color" className="color_picker_input" value={this.state.chosenOptionColor} id="chosenOptionColor" onChange={e => this.updateState({chosenOptionColor: e.target.value})} />
									<div className="color_option_title">Radio Button Color</div>
								</div>
							</div>
							
						</div>
						*/}
						<div className="saveBtn reset_default_settings"> 
							{ this.state.channelMainData.subdomain && this.state.channelMainData.subdomain !== '' &&
								<div className="preview_button_channel mb15 font17" onClick={() => this.openPreviews('channel')}>Preview Channel Page</div>
							}
							{ this.state.channelMainData.subdomain && this.state.channelMainData.subdomain !== '' &&
								<div className="preview_button_channel mb15 font17" onClick={() => this.openPreviews('channelsign')}>Preview Channel Sign Up Page</div>
							}
							<div className="reset_button_channel mb15 font17" onClick={e=>{this.resetDefaultSettings()}}>Reset Default</div>
						</div>
					</div>
				}
			</div>
			{ this.state.selectedMenu !== 'External API' && <div className="saveBtn"><div onClick={e=>{this.updateChannelSettings()}}>SAVE</div></div> }
			<div className="main_loader">
				<div className="main_loader_inner"></div>
			</div>
			
			
			<div className="modal pr-0" id="mindbodyIntegrate" aria-modal="true"> 
				<div className="modal-dialog mw-570 mx-auto modal-dialog-centered">
					<div className="modal-content bg-transparent mindbody_back">
						<div className="mind_close" onClick={e=>$('#mindbodyIntegrate').attr({'style':'display:none'})}></div>
						<div className="modal-body px-4 py-4 modl_bg_drk m-2 radius-8 shadow-none mindbody_back txt_center">
							<div className="mindbody_logo"></div>
							<div className="mindbody_logo_subtxt">Sign in to your Mindbody account</div>
							<div className="mindbody_form">
								<div className = "form-group pb-3 mb-0 mt-4">
									<label className="mainLabel">Username</label>
									<input type="text" id="usernameMindbody" value={this.state.usernameMindbody} className="form-control white_clr" onChange={(e)=> this.setState({[e.target.id]:e.target.value})} maxLength="40" />
								</div>
								<div className = "form-group pb-3 mb-0 mt-4">
									<label className="mainLabel">Password</label>
									<input type="password" id="passwordMindbody" value={this.state.passwordMindbody} className="form-control white_clr" onChange={(e)=> this.setState({[e.target.id]:e.target.value})} maxLength="40" />
								</div>
								<div className = "form-group pb-3 mb-0 mt-4">
									<label className="mainLabel">Site Id</label>
									<input type="text" id="siteIdMindbody" value={this.state.siteIdMindbody} className="form-control white_clr" onChange={(e)=> this.setState({[e.target.id]:e.target.value})} maxLength="10" />
								</div>
							</div>
						</div>
						<div className="text-center for_bnt_mind"><button type="button" className="custom_btn1 btn_mind" onClick={this.autheniticateMindbody}>Login</button></div>
					</div>
				</div>
			</div>
			
			<div className="modal pr-0" id="csiIntegrate" aria-modal="true"> 
				<div className="modal-dialog mw-570 mx-auto modal-dialog-centered">
					<div className="modal-content bg-transparent mindbody_back">
						<div className="mind_close" onClick={e=>$('#csiIntegrate').attr({'style':'display:none'})}></div>
						<div className="modal-body px-4 py-4 modl_bg_drk m-2 radius-8 shadow-none mindbody_back txt_center">
							<div className="csi_logo"></div>
							<div className="mindbody_logo_subtxt">Sign in to your CSI account</div>
							<div className="mindbody_form">
								<div className = "form-group pb-3 mb-0 mt-4">
									<label className="mainLabel">Enter your Member number</label>
									<input type="text" id="memberNum" value={this.state.memberNum} className="form-control white_clr" onChange={(e)=> this.setState({[e.target.id]:e.target.value})} maxLength="40" />
								</div>
							</div>
						</div>
						<div className="text-center for_bnt_mind"><button type="button" className="custom_btn1 btn_mind" onClick={this.autheniticateCSI}>Authenticate</button></div>
					</div>
				</div>
			</div>
			<div className="modal cal_modal mt-3" id="calenderModel" data-backdrop="">
			  <div className="modal-dialog d-md-flex d-block large_width1 mb-0">
				<div className="modal-content modalbg m-auto relative">
				  <div className="modal-header px-4 pt-3 pb-0">
					<h4 className="white modal-title">Choose Date and Time</h4>
					<button type="button pr-3" className="close white closepopup" onClick={e=>$("#calenderModel").attr({'style':'display:none'})}>&times;</button>
				  </div>
				  <div className="modal-body modal-body px-1 px-sm-3">
				  <h3>Calender</h3>

					<Calendar
					   onChange={this.onChange1}
					   value={this.state.sessionCalender}
					   minDate={new Date()}
					  // calendarType= "ISO 8601"
					 />
				  <div className="botm_container">
					<div className="row mx-0 mt-4 justify-content-between flex-wrap">
					  
					  
					  
					   <div className="mt-2 px-1 px-sm-2">
					 
					 
					  </div>
					  <div className="col-md-6 pr-4 d-none">
					  {/* <p className="mb-2 input-txt">On {this.state.sessionMonth} {this.state.sessionDay} {this.state.sessionYear}, at {this.state.sessionTime}</p> */}
					  {/* <div className="form-group input-txt mb-0">
						  <label className="switch">
							  <input type="checkbox" 
							  id="repeatSession"
							  checked={this.state.repeatSession}
							  onChange={(e)=> this.setState({[e.target.id]:!this.state.repeatSession},()=>console.log(this.state.repeatSession))}
							  />
							  <span className="slider round"></span>
						  </label>
						  <span>This is a repeated class</span>
						</div> */}
						
					  </div>
					</div>
				  </div>
				  </div>
					<div className="text-center position-absolute btn_btn1">
					{this.state.repeatSession?'':<button type="button" className="done mt-0" onClick={this.sessionDate} >done</button>}
					</div>
				  </div>
				  {this.state.repeatSession?
				  <div className="wd align-self-end d-none d-md-block"><img src="/images/path.png" className="w-100" /></div>:''}
				  {this.state.repeatSession?
				  <div className="modal-content modalbg align-self-end px-4 py-4 mt-2 mt-md-0">
				  <div className="modal-header headerborder px-0">
				  <div style={{color:"red"}}>This feature is't available</div>
					<h4 className="white modal-title">Repeat Class</h4>
				  </div>
				  <div className="modal-body px-0">
				  <h5 className="white">Frequency</h5>
				  <div className="d-flex flex-wrap">
				  <a href="#" id='varietal' name='0' onClick = {this.sessionAttribute} className={(this.state.sessionClass[0]?"btn btn-primary":"")+" btn btn-outline-secondary text-uppercase mr-2 mt-2"}>varietal</a>
				  <a href="#" id='Every day' name='1' onClick = {this.sessionAttribute} className={(this.state.sessionClass[1]?"btn btn-primary":"btn")+" btn-outline-secondary text-uppercase mr-2 mt-2"}>Every day</a>
				  <a href="#" id='once a week' name='2' onClick = {this.sessionAttribute} className={(this.state.sessionClass[2]?"btn btn-primary":"btn")+" btn-outline-secondary text-uppercase mr-2 mt-2"}>once a week</a>
				  <a href="#" id='twice a week' name='3' onClick = {this.sessionAttribute} className={(this.state.sessionClass[3]?"btn btn-primary":"btn")+" btn-outline-secondary text-uppercase mr-2 mt-2"}>twice a week</a>
				  <a href="#" id='3 times a week' name='4' onClick = {this.sessionAttribute} className={(this.state.sessionClass[4]?"btn btn-primary":"btn")+" btn-outline-secondary text-uppercase mr-2 mt-2"}>3 times a week</a>
				  <select className="custom_field mt-2 mb-0" 
				  id="sessionFrequency"
				  value = {this.state.sessionFrequency}
				  onChange = {this.sessionInfo}>
					<option>custom</option>
					<option>1 week</option>
					<option>2 week</option>
					<option>3 week</option>
					<option>4 week</option>
					</select>
				  </div>
				  <h5 className="white mt-4">Duration</h5>
				  <div className="d-flex flex-wrap">
				  <a href="#" id='1 week' name='5' onClick = {this.sessionAttribute} className={(this.state.sessionClass[5]?"btn btn-primary":"")+" btn btn-outline-secondary text-uppercase mr-2 mt-2"}>1 week</a>
				  <a href="#" id='2 weeks' name='6' onClick = {this.sessionAttribute} className={(this.state.sessionClass[6]?"btn btn-primary":"")+" btn btn-outline-secondary text-uppercase mr-2 mt-2"}>2 weeks</a>
				  <a href="#" id='3 weeks' name='7' onClick = {this.sessionAttribute} className={(this.state.sessionClass[7]?"btn btn-primary":"")+" btn btn-outline-secondary text-uppercase mr-2 mt-2"}>3 weeks</a>
				  <a href="#" id='4 weeks' name='8' onClick = {this.sessionAttribute} className={(this.state.sessionClass[8]?"btn btn-primary":"")+" btn btn-outline-secondary text-uppercase mr-2 mt-2"}>4 weeks</a>
				  <a href="#" id='5 weeks' name='9' onClick = {this.sessionAttribute} className={(this.state.sessionClass[9]?"btn btn-primary":"")+" btn btn-outline-secondary text-uppercase mr-2 mt-2"}>5 weeks</a>
				  <select className="custom_field mt-2 mb-0" 
				  id="sessionDuration"
				  value = {this.state.sessionDuration}
				  onChange = {this.sessionInfo}
				  >
					<option>custom</option>
					<option>1 week</option>
					<option>2 week</option>
					<option>3 week</option>
					<option>4 week</option>
					</select>
				  </div>
				  </div>
				  <div className="text-center position-absolute btn_btn1">
					  <button type="button" onClick={this.saveSessionCalenderDetail} className="done mt-0">save</button>
				  </div>
				 {/* <img src="images/path.png" className="small_cont" /> */}
				  {/* <div className="modalbg small_cont"></div> */}
				  </div>:''}
			  </div>
			</div>
			<SupportContainer supportPageName={this.state.supportPageName} supportPageApi={this.state.supportPageApi} userTypeFaqs={this.state.userTypeFaqs}></SupportContainer>
		</div>
    );
  }
}

export default connect(
  null,
  { 
	showMainErrorPop
  }
)(ChannelSettings);